import { startCase, toLower } from 'lodash';

export default class StringUtils {
  /**
   * Convert “foo bar” → “Foo Bar”
   * @param {string} str
   * @returns {string}
   */
  static toTitleCase(str) {
    return startCase(toLower(str));
  }
}
